import { useState } from "react";
import CatSelect from "../../cat/CatSelect";
import { CommonDialog } from "../../common/CommonDialog";
import CmsService from "../../../service/CmsService";
import { Form } from "../../common/Form";
import { useTranslation } from "react-i18next";

export function CrtForm({onChange})
{
    const {t}=useTranslation();
    const [crt,setCrt] = useState({});

    const onSelectCat=(cat)=>{
        var crtNew={...crt,catId:cat.id};
        setCrt(crtNew);
        onChange(crtNew);
    }
    const onValChange=(data)=>{
        var crtNew={...crt,...data};
        setCrt(crtNew);
        onChange(crtNew);
    }

    return(
        <>
		<div style={{width:'40rem',height:'20rem'}}>	
            <div className="formgrid grid">
                <div className="field col-12">
                    <label htmlFor="catSelect">{t('Category')}</label>
                    <CatSelect inputId="catSelect" className="w-full" value={crt.catId} onSelect={onSelectCat}></CatSelect>
                </div>
            </div>

            <Form id="formid" formData={crt} columns="2" onChange={onValChange}
                fields={[
                    {id:"name",ftype:"text",field:"name",label:t("Name")}
                ]}>
            </Form>	
		</div>
        </>
    )
}
export function CrtDialog({visible,onOK,onCancel})
{
    const [crt,setCrt]=useState({});

    const _onOK=()=>{
        CmsService.createCrt(crt).then((ret)=>{
            onOK(ret);
        });
    }
    const _onCancel=()=>{onCancel()}
    const onChange=(data)=>{setCrt(data)}

    return(
        <CommonDialog visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <CrtForm onChange={onChange}></CrtForm>
        </CommonDialog>
    )
}